const isEnabled = (value) => String(value).toLowerCase() === 'true';

export const AI_CHAT_ENABLED = isEnabled(process.env.REACT_APP_AI_CHAT_ENABLED);